import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const CustomNavLink = ({ to, children }) => {
  const location = useLocation();
  const isActive = location.pathname === to;
  var className = isActive ? "nav-item active" : "nav-item";
  return (
    <NavLink
      to={to}
      className={`md:px-8 px-4 font-medium sm:text-base xs:text-sm ${className}`}
    >
      {children}
    </NavLink>
  );
};

export default CustomNavLink;
